<template>
  <div class="con-wrap">
    <div class="data-wrap">
      <div class="top">
        <el-button type="primary" @click="goDetail">返回</el-button>
        <el-button type="primary" @click="exportFile">数据导出</el-button>
        <el-button type="primary" @click="cloumnChoice">数据列选择</el-button>
        <el-button type="primary" @click="contrastData">数据比对</el-button>
      </div>
      <el-row class="power-data">
        <el-row class="data-title">
          <el-col :span="3">车辆绑定人</el-col>
          <el-col :span="3">车主账号</el-col>
          <el-col :span="3">车牌号</el-col>
          <el-col :span="3">发电开始时间</el-col>
          <el-col :span="3">发电结束时间</el-col>
          <el-col :span="3">发电量（kW·h）</el-col>
          <el-col :span="3">发电时长</el-col>
          <el-col :span="3">发电油耗（L）</el-col>
        </el-row>
        <el-row class="data-value">
          <el-col :span="3">{{ powerData.name }}</el-col>
          <el-col :span="3">{{ powerData.account }}</el-col>
          <el-col :span="3">{{ powerData.plateNum }}</el-col>
          <el-col :span="3">{{ powerData.startTime }}</el-col>
          <el-col :span="3">{{ powerData.endTime }}</el-col>
          <el-col :span="3">{{ powerData.capacity }}</el-col>
          <el-col :span="3">{{ powerData.duration }}</el-col>
          <el-col :span="3">{{ powerData.oil }}</el-col>
        </el-row>
      </el-row>
      <div class="data-box">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="车辆数据" name="first">
            <el-table
              ref="multipleTable"
              :data="vehicleData"
              class="vehicleTable"
              tooltip-effect="dark"
              size="mini"
              style="width: 100%"
              max-height="520"
              highlight-current-row
              v-loading="loading"
              element-loading-text="拼命加载中"
              :cell-style="cellStyle"
            >
              <el-table-column
                v-for="(item, index) in vehicleTitle"
                :key="`vehicle_${index}`"
                :prop="dropVehicleTitle[index].prop"
                :label="item.label"
                :width="item.label == '序号' ? 55 : 164"
                :fixed="
                  item.label == '时间' || item.label == '序号' ? true : false
                "
              >
              </el-table-column>
              <!-- <el-table-column
                type="index"
                label="序号"
                fixed="left"
                width="55"
                align="center"
              ></el-table-column> -->
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="发电数据" name="second">
            <el-table
              ref="multipleTable"
              :data="powerData2"
              class="powerTable"
              highlight-current-row
              tooltip-effect="dark"
              size="mini"
              style="width: 100%"
              max-height="520"
              v-loading="loading2"
              element-loading-text="拼命加载中"
              :cell-style="cellStyle"
            >
              <el-table-column
                v-for="(item, index) in powerTitle"
                :key="`powerTitle_${index}`"
                :prop="dropPowerTitle[index].prop"
                :label="item.label"
                :width="changeWidth(item)"
                :fixed="
                  item.label == '时间' || item.label == '序号' ? true : false
                "
              >
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-pagination
            style="margin-top:20px;"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="limit"
            layout="prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </el-tabs>
      </div>
    </div>
    <!-- 数据项选择 -->
    <el-dialog title="数据列选择" :visible.sync="choiceVisible" class="">
      <div class="dialogCon">
        <el-row>
          <el-col :span="12">
            <p class="dialog-title">车辆数据</p>
            <div class="checkBoxs">
              <el-checkbox
                :indeterminate="powerIndeterminate2"
                v-model="checkAll2"
                @change="checkAllChange2"
                >全选</el-checkbox
              >
              <el-checkbox-group
                v-model="checkedVehicle"
                @change="vehicleChange"
              >
                <el-checkbox
                  v-for="vehicle in vehicleDatas"
                  :label="vehicle.label + '&' + vehicle.prop"
                  :key="vehicle.label"
                  class="checkboxRow"
                  :disabled="
                    vehicle.prop == 'index' || vehicle.prop == 'ts'
                      ? true
                      : false
                  "
                  >{{ vehicle.label }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </el-col>
          <el-col :span="12">
            <p class="dialog-title">发电数据</p>
            <div class="checkBoxs">
              <el-checkbox
                :indeterminate="powerIndeterminate1"
                v-model="checkAll1"
                @change="checkAllChange1"
                >全选</el-checkbox
              >
              <el-checkbox-group v-model="checkedPower" @change="powerChange">
                <el-checkbox
                  v-for="power in powerDatas"
                  :label="power.label + '&' + power.prop"
                  :key="power.label"
                  class="checkboxRow"
                  :disabled="
                    power.prop == 'index' || power.prop == 'ts' ? true : false
                  "
                  >{{ power.label }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="choiceVisible = false">取 消</el-button>
        <el-button type="primary" @click="choiceColumn">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 数据比对 -->
    <el-dialog
      title="数据比对"
      :visible.sync="contrastVisible"
      class="contrastDialog"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <p class="dialog-title">车辆数据</p>
          <el-table
            ref="multipleTable1"
            :data="vehicleData1"
            class="vehicleTable"
            tooltip-effect="dark"
            size="mini"
            style="width: 100%"
            max-height="520"
            highlight-current-row
            v-loading="loading"
            element-loading-text="拼命加载中"
            :cell-style="cellStyle"
          >
            <el-table-column
              v-for="(item, index) in vehicleTitle"
              :key="`vehicle_${index}`"
              :prop="dropVehicleTitle[index].prop"
              :label="item.label"
              :width="item.label == '序号' ? 55 : 164"
              :fixed="
                item.label == '时间' || item.label == '序号' ? true : false
              "
            >
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange1"
            :current-page.sync="currentPage1"
            :page-size="limit"
            layout="prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </el-col>
        <el-col :span="12">
          <p class="dialog-title">发电数据</p>
          <el-table
            ref="multipleTable2"
            :data="powerData1"
            class="powerTable"
            highlight-current-row
            tooltip-effect="dark"
            size="mini"
            style="width: 100%"
            max-height="520"
            v-loading="loading2"
            element-loading-text="拼命加载中"
            :cell-style="cellStyle"
          >
            <el-table-column
              v-for="(item, index) in powerTitle"
              :key="`powerTitle_${index}`"
              :prop="dropPowerTitle[index].prop"
              :label="item.label"
              :width="item.label == '序号' ? 55 : 164"
              :fixed="
                item.label == '时间' || item.label == '序号' ? true : false
              "
            >
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handlePCurrentChange1"
            :current-page.sync="pCurrentPage1"
            :page-size="pLimit"
            layout="prev, pager, next, jumper"
            :total="pTotal"
          ></el-pagination>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import Sortable from "sortablejs";
export default {
  name: "PowerMore",
  props: {
    vin: {
      type: String,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      activeName: "first",
      powerData: {},
      vehicleData: [],
      currentPage: 1,
      limit: 100,
      total: 0,
      powerData2: [],
      loading2: false,
      loading: false,
      vehicleTitle: [],
      dropVehicleTitle: [],
      powerTitle: [],
      dropPowerTitle: [],
      // 列表项可选
      choiceVisible: false,
      vehicleDatas1: [
        { label: "序号", prop: "index" },
        { label: "时间", prop: "ts" },
        { label: "添加时间", prop: "addTs" },
        { label: "是否为补传数据", prop: "makeUp" },
        { label: "车速信号(km/h)", prop: "absVehicleSpeed" },
        { label: "发动机转速(RPM)", prop: "emsEngineSpeed" },
        { label: "发动机冷却液温度(℃)", prop: "emsEngineCoolanTemperature" },
        { label: "里程(km)", prop: "totalMileage" },
        { label: "平均油耗(L/100km)", prop: "emsFuleConsumption" },
        { label: "电源电压(V)", prop: "emsBatteryVoltage" },
        { label: "发动机转速故障", prop: "emsEngineSpeedError" },
        { label: "发动机冷却液温度过高", prop: "emsHigherror" },
        { label: "加速踏板故障", prop: "emsAccpedelError" },
        { label: "进气温度传感器故障", prop: "emsIntakeAirTempSensorError" },
        { label: "节气门位置故障", prop: "emsThrottleValuePositionError" },
        { label: "电源电压故障检测", prop: "emsBatteryVoltageError" },
        { label: "发动机冷却液温度故障", prop: "emsCoolanTemperatureError" },
        { label: "发动机故障指示灯", prop: "emsMil" },
      ],
      vehicleDatas2: [
        { label: "序号", prop: "index" },
        { label: "时间", prop: "ts" },
        { label: "添加时间", prop: "addTs" },
        { label: "发电机控制器温度(℃)", prop: "igbttemp" },
        { label: "电池 SOC(%)", prop: "vcuBattSoc" },
        { label: "电池总电压(V)", prop: "bmsBattU" },
        { label: "电池充/放电电流(A)", prop: "bmsBattCrrt" },
        { label: "电池充放电功率(Kw)", prop: "bmsBattPower" },
        { label: "电池充/放电状态", prop: "vehChrgSts" },
        { label: "发电机输出电压(V)", prop: "dcMainWireVolt" },
        { label: "发电机输出电流(A)", prop: "dcMainWireCurr" },
        { label: "发电机输出功率(Kw)", prop: "dcMainWirePower" },
        { label: "是否为补传数据", prop: "makeUp" },
        { label: "车速信号(km/h)", prop: "absVehicleSpeed" },
        { label: "发动机转速(RPM)", prop: "emsEngineSpeed" },
        { label: "发动机冷却液温度(℃)", prop: "emsEngineCoolanTemperature" },
        { label: "里程(km)", prop: "totalMileage" },
        { label: "平均油耗(L/100km)", prop: "emsFuleConsumption" },
        { label: "电源电压(V)", prop: "emsBatteryVoltage" },
        { label: "发动机转速故障", prop: "emsEngineSpeedError" },
        { label: "发动机冷却液温度过高", prop: "emsHigherror" },
        { label: "加速踏板故障", prop: "emsAccpedelError" },
        { label: "进气温度传感器故障", prop: "emsIntakeAirTempSensorError" },
        { label: "节气门位置故障", prop: "emsThrottleValuePositionError" },
        { label: "电源电压故障检测", prop: "emsBatteryVoltageError" },
        { label: "发动机冷却液温度故障", prop: "emsCoolanTemperatureError" },
        { label: "发动机故障指示灯", prop: "emsMil" },
      ],
      vehicleEcho: [
        "序号&index",
        "时间&ts",
        "添加时间&addTs",
        "发电机控制器温度(℃)&igbttemp",
        "电池 SOC(%)&vcuBattSoc",
        "电池总电压(V)&bmsBattU",
        "电池充/放电电流(A)&bmsBattCrrt",
        "电池充放电功率(Kw)&bmsBattPower",
        "电池充/放电状态&vehChrgSts",
        "发电机输出电压(V)&dcMainWireVolt",
        "发电机输出电流(A)&dcMainWireCurr",
        "发电机输出功率(Kw)&dcMainWirePower",
        "是否为补传数据&makeUp",
        "车速信号(km/h)&absVehicleSpeed",
        "发动机转速(RPM)&emsEngineSpeed",
        "发动机冷却液温度(℃)&emsEngineCoolanTemperature",
        "里程(km)&totalMileage",
        "平均油耗(L/100km)&emsFuleConsumption",
        "电源电压(V)&emsBatteryVoltage",
        "发动机转速故障&emsEngineSpeedError",
        "发动机冷却液温度过高&emsHigherror",
        "加速踏板故障&emsAccpedelError",
        "进气温度传感器故障&emsIntakeAirTempSensorError",
        "节气门位置故障&emsThrottleValuePositionError",
        "电源电压故障检测&emsBatteryVoltageError",
        "发动机冷却液温度故障&emsCoolanTemperatureError",
        "发动机故障指示灯&emsMil",
      ],
      powerDatas: [
        { label: "序号", prop: "index" },
        { label: "时间", prop: "ts" },
        { label: "添加时间", prop: "addTs" },
        { label: "是否为补传数据", prop: "makeUp" },
        { label: "发电时长(分钟)", prop: "duration" },
        { label: "发电机发电状态", prop: "state" },
        { label: "发电量(KW·H)", prop: "capacity" },
        { label: "总正向有功功率(W)", prop: "forwardPower" },
        { label: "发电平均油耗(L/H)", prop: "generatorFuleConsumption" },
        { label: "剩余油量(L)", prop: "adFuel" },
        { label: "频率(HZ)", prop: "frequency" },
        { label: "电表总发电量(KW·H)", prop: "energy" },
        { label: "发电机温度(℃)", prop: "ptoTemperature" },
        { label: "L1电压有效值(V)", prop: "l1Voltage" },
        { label: "L2电压有效值(V)", prop: "l2Voltage" },
        { label: "L3电压有效值(V)", prop: "l3Voltage" },
        { label: "L1电流有效值(A)", prop: "l1Electricity" },
        { label: "L2电流有效值(A)", prop: "l2Electricity" },
        { label: "L3电流有效值(A)", prop: "l3Electricity" },
        { label: "发电机过载告警", prop: "overloadAlarm" },
        { label: "发电机缺相告警", prop: "phaseAlarm" },
        { label: "发电机短路告警", prop: "shortAlarm" },
        { label: "发电档位错误", prop: "gearsError" },
        { label: "发电中踩离合故障", prop: "cluthError" },
        { label: "发电诊断错误", prop: "diagnoseError" },
        { label: "发电机高温报警", prop: "ptoHighttemperatureAlarm" },
      ],
      powerEcho: [
        "序号&index",
        "时间&ts",
        "添加时间&addTs",
        "是否为补传数据&makeUp",
        "发电机发电状态&state",
        "发电时长(分钟)&duration",
        "发电量(KW·H)&capacity",
        "总正向有功功率(W)&forwardPower",
        "发电平均油耗(L/H)&generatorFuleConsumption",
        "剩余油量(L)&adFuel",
        "频率(HZ)&frequency",
        "电表总发电量(KW·H)&energy",
        "发电机温度(℃)&ptoTemperature",
        "L1电压有效值(V)&l1Voltage",
        "L2电压有效值(V)&l2Voltage",
        "L3电压有效值(V)&l3Voltage",
        "L1电流有效值(A)&l1Electricity",
        "L2电流有效值(A)&l2Electricity",
        "L3电流有效值(A)&l3Electricity",
        "发电机过载告警&overloadAlarm",
        "发电机缺相告警&phaseAlarm",
        "发电机短路告警&shortAlarm",
        "发电档位错误&gearsError",
        "发电中踩离合故障&cluthError",
        "发电诊断错误&diagnoseError",
        "发电机高温报警&ptoHighttemperatureAlarm",
      ],
      powerIndeterminate1: true,
      powerIndeterminate2: true,
      checkAll1: false,
      checkAll2: false,
      checkedVehicle: ["序号&index", "时间&ts"],
      checkedPower: ["序号&index", "时间&ts"],
      choiceVehicleTitle: [],
      choicePowerTitle: [],
      contrastVisible: false,
      powerData1: [],
      vehicleData1: [],
      currentPage1: 1,
      pCurrentPage1: 1,
      pLimit: 100,
      pTotal: 0,
      vehicleDatas: [],
    };
  },
  created() {
    this.getVehicleTitle();
    this.getPowerTitle();
    let version = sessionStorage.getItem("version");
    this.vehicleDatas = version == 1 ? this.vehicleDatas1 : this.vehicleDatas2;
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.powerDrop();
        this.vechileDrop();
      }, 100);
      7;
    });
    this.getData();
  },
  methods: {
    changeWidth(item) {
      if (item.prop == "index") {
        return 55;
      } else if (item.prop == "tgcuInstPower" || item.prop == "tgcuAverPower") {
        return 210;
      } else {
        return 164;
      }
    },
    // 处理是否为补传数据显示
    handleMakeUpData(makeUp) {
      if (makeUp == 0) {
        return "否";
      } else if (makeUp == 1) {
        return "是";
      } else {
        return "-";
      }
    },
    // 处理电池充/放电状态数据显示
    handleVehChrgStsData(vehChrgSts) {
      if (vehChrgSts == 1) {
        return "停车充电";
      } else if (vehChrgSts == 2) {
        return "行驶充电";
      } else if (vehChrgSts == 3) {
        return "未充电";
      } else if (vehChrgSts == 4) {
        return "充电完成";
      } else {
        return "-";
      }
    },
    // 改变表格列数据样式【单元格的 style 的回调方法】
    cellStyle({ row, column }) {
      let version = sessionStorage.getItem("version");
      if (version == 1) {
        // 用来改变1.0发电电流数值超过32A时字体颜色变红
        if (column.property == "l1Electricity" && row.l1Electricity > 32) {
          return "color:#f53929";
        }
        if (column.property == "l2Electricity" && row.l2Electricity > 32) {
          return "color:#f53929";
        }
        if (column.property == "l3Electricity" && row.l3Electricity > 32) {
          return "color:#f53929";
        }
        // 用来改变1.0车发电机温度数值高于90度时字体颜色变红
        if (column.property == "ptoTemperature" && row.ptoTemperature >= 90) {
          return "color:#f53929";
        }
      } else if (version == 2) {
        // 用来改变2.0车辆发电电流数值超过65.3A时字体颜色变红
        if (column.property == "l1Electricity" && row.l1Electricity > 65.3) {
          return "color:#f53929";
        }
        if (column.property == "l2Electricity" && row.l2Electricity > 65.3) {
          return "color:#f53929";
        }
        if (column.property == "l3Electricity" && row.l3Electricity > 65.3) {
          return "color:#f53929";
        }
        // 用来改变2.0车发电机温度数值高于138度时字体颜色变红
        if (column.property == "ptoTemperature" && row.ptoTemperature > 138) {
          return "color:#f53929";
        }
        // 用来改变2.0车发动机冷却液温度数值高于114度时字体颜色变红
        if (
          column.property == "emsEngineCoolanTemperature" &&
          row.emsEngineCoolanTemperature > 114
        ) {
          return "color:#f53929";
        }
      }
      // 用来改变电压数值低于200时字体颜色变红
      if (column.property == "l1Voltage" && row.l1Voltage < 200) {
        return "color:#f53929";
      }
      if (column.property == "l2Voltage" && row.l2Voltage < 200) {
        return "color:#f53929";
      }
      if (column.property == "l3Voltage" && row.l3Voltage < 200) {
        return "color:#f53929";
      }
      // 用来改变频率数值低于47时字体颜色变红
      if (column.property == "frequency" && row.frequency < 47) {
        return "color:#f53929";
      }
    },
    // 时间戳转换为日期格式数据
    timestampToTime(timestamp) {
      if (timestamp) {
        // 如果时间戳为空时，会显示计算机起始计时时间，1970-01-01 8:00:00
        // 时间戳为10位需*1000，时间戳为13位不需乘1000
        var date = new Date(timestamp * 1000);
        var Y = date.getFullYear() + "-";
        var M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        var D =
          (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        var h =
          date.getHours() < 10
            ? "0" + date.getHours() + ":"
            : date.getHours() + ":";
        var m =
          date.getMinutes() < 10
            ? "0" + date.getMinutes() + ":"
            : date.getMinutes() + ":";
        var s =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        return Y + M + D + h + m + s;
      } else {
        return "-";
      }
    },
    //动态表头开始
    async getVehicleTitle() {
      this.dropVehicleTitle = [];
      this.vehicleTitle = [];
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/vehicle/details/history/title",
        {
          params: {
            type: 1,
            vin: _this.vin,
          },
        }
      );
      if (res.code == 1) {
        for (let i = 0; i < res.data.length; i++) {
          let val = {};
          val.label = res.data[i].label;
          val.prop = res.data[i].prop;
          _this.dropVehicleTitle.push(val);
          _this.vehicleTitle.push(val);
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    async getPowerTitle() {
      this.powerTitle = [];
      this.dropPowerTitle = [];
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/vehicle/details/history/title",
        {
          params: {
            type: 2,
            vin: _this.vin,
          },
        }
      );
      if (res.code == 1) {
        for (let i = 0; i < res.data.length; i++) {
          let val = {};
          val.label = res.data[i].label;
          val.prop = res.data[i].prop;
          _this.powerTitle.push(val);
          _this.dropPowerTitle.push(val);
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    vechileDrop() {
      let _this = this;
      const vehicleTr = document.querySelector(
        ".vehicleTable .el-table__header-wrapper tr"
      );
      _this.sortable = Sortable.create(vehicleTr, {
        animation: 180,
        delay: 0,
        onEnd: (evt1) => {
          const oldVehicleItem = _this.dropVehicleTitle[evt1.oldIndex];
          _this.dropVehicleTitle.splice(evt1.oldIndex, 1)[0];
          _this.dropVehicleTitle.splice(evt1.newIndex, 0, oldVehicleItem);
          _this.saveVehicleTitle(_this.dropVehicleTitle);
        },
      });
    },
    powerDrop() {
      let _this = this;
      const powerTr = document.querySelector(
        ".powerTable .el-table__header-wrapper tr"
      );
      _this.sortable = Sortable.create(powerTr, {
        animation: 180,
        delay: 0,
        onEnd: (evt) => {
          const oldPowerItem = _this.dropPowerTitle[evt.oldIndex];
          _this.dropPowerTitle.splice(evt.oldIndex, 1);
          _this.dropPowerTitle.splice(evt.newIndex, 0, oldPowerItem);
          _this.savePowerTitle(_this.dropPowerTitle);
        },
      });
    },
    async saveVehicleTitle(title) {
      console.log(title);
      let obj = {};
      obj.titles = title;
      obj.type = 1;
      let _this = this;
      obj.vin = _this.vin;
      let { data: res } = await _this.$axios.post(
        "/api/vehicle/details/history/title",
        obj
      );
      if (res.code == 1) {
        console.log(res.msg);
      } else {
        _this.$message.warning(res.msg);
      }
    },
    async savePowerTitle(title) {
      console.log(title);
      let obj = {};
      obj.titles = title;
      obj.type = 2;
      let _this = this;
      obj.vin = _this.vin;
      let { data: res } = await _this.$axios.post(
        "/api/vehicle/details/history/title",
        obj
      );
      if (res.code == 1) {
        console.log(res.msg);
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //动态表头结束
    goDetail() {
      this.$emit("gotoDetail");
    },
    // 文件导出
    exportFile() {
      let _this = this;
      let url = "";
      if (_this.activeName == "first") {
        url =
          "/api/vehicle/details/vehicle/export?vin=" +
          _this.vin +
          "&startTime=" +
          _this.powerData.startTime +
          "&endTime=" +
          _this.powerData.endTime;
      } else {
        url =
          "/api/vehicle/details/dynamo/export?vin=" +
          _this.vin +
          "&startTime=" +
          _this.powerData.startTime +
          "&endTime=" +
          _this.powerData.endTime;
      }
      window.location.href = url;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      if (this.activeName == "first") {
        this.getVehicleData(this.currentPage);
      } else if (this.activeName == "second") {
        this.getPowerData(this.currentPage);
      }
    },
    //   查询发电数据
    async getData() {
      let _this = this;
      let id = this.id;
      let { data: res } = await _this.$axios.get(
        `/api/vehicle/details/dynamo/counts/more/${id}`
      );
      if (res.code == 1) {
        _this.powerData = res.data;
        _this.getVehicleData(_this.currentPage);
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 获取车辆历史数据
    async getVehicleData(curPage) {
      let _this = this;
      _this.loading = true;
      let obj = {
        recordId: _this.id,
        page: curPage,
        limit: _this.limit,
        // startTime: _this.powerData.startTime,
        // endTime: _this.powerData.endTime,
      };
      let { data: res } = await _this.$axios.get(
        "/api/vehicle/details/vehicle/history/record",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        _this.loading = false;
        _this.total = res.data.totalCount;
        let dataList = res.data.list;

        //for循环最优性能处理方式
        for (let i = dataList.length - 1; i >= 0; i--) {
          // 车速
          dataList[i].absVehicleSpeed = _this.speedHandle(
            dataList[i].absVehicleSpeed
          );
          // 电源电压
          dataList[i].emsBatteryVoltage = _this.handle255(
            dataList[i].emsBatteryVoltage
          );
          //行驶平均油耗
          dataList[i].emsFuleConsumption = _this.handle25(
            dataList[i].emsFuleConsumption
          );
          // 发动机冷却液温度
          dataList[i].emsEngineCoolanTemperature = _this.handle207(
            dataList[i].emsEngineCoolanTemperature
          );
          //发动机转速
          dataList[i].emsEngineSpeed = _this.engineHandle(
            dataList[i].emsEngineSpeed
          );
          // 里程
          dataList[i].totalMileage = _this.invalidData(
            dataList[i].totalMileage
          );
          // 冷却液温度过高
          dataList[i].emsHigherror = _this.judgePowerData(
            dataList[i].emsHigherror
          );
          // 进气温度传感器故障
          dataList[i].emsIntakeAirTempSensorError = _this.judgeData(
            dataList[i].emsIntakeAirTempSensorError
          );
          // 加速踏板故障
          dataList[i].emsAccpedelError = _this.judgeData(
            dataList[i].emsAccpedelError
          );
          // 节气门位置故障
          dataList[i].emsThrottleValuePositionError = _this.judgeData(
            dataList[i].emsThrottleValuePositionError
          );
          // 发动着转速故障
          dataList[i].emsEngineSpeedError = _this.judgeData(
            dataList[i].emsEngineSpeedError
          );
          // 电源电压故障
          dataList[i].emsBatteryVoltageError = _this.judgeData(
            dataList[i].emsBatteryVoltageError
          );
          // 发动机冷却液温度故障
          dataList[i].emsCoolanTemperatureError = _this.judgeData(
            dataList[i].emsCoolanTemperatureError
          );
          // 发动机故障指示灯
          dataList[i].emsMil = _this.analysisEmsData(dataList[i].emsMil);
          // 补传数据添加时间
          dataList[i].addTs = _this.timestampToTime(dataList[i].addTs);
          // 判断是否为补传数据
          dataList[i].makeUp = _this.handleMakeUpData(dataList[i].makeUp);
          // 电池SOC
          dataList[i].vcuBattSoc =
            dataList[i].vcuBattSoc == 255 ? "-" : dataList[i].vcuBattSoc;
          // 电池总电压
          dataList[i].bmsBattU =
            dataList[i].bmsBattU == 6553.5
              ? "-"
              : _this.handlePointData(dataList[i].bmsBattU);
          // 处理充放电电流
          dataList[i].bmsBattCrrt =
            dataList[i].bmsBattCrrt == 5553.5
              ? "-"
              : _this.handlePointData(dataList[i].bmsBattCrrt);
          // 处理充放电功率
          dataList[i].bmsBattPower =
            dataList[i].bmsBattPower == 5553.5
              ? "-"
              : _this.handlePointData(dataList[i].bmsBattPower);
          // 处理充放电状态
          dataList[i].vehChrgSts = _this.handleVehChrgStsData(
            dataList[i].vehChrgSts
          );
          // 发电机输出电压
          dataList[i].dcMainWireVolt =
            dataList[i].dcMainWireVolt == 6553.5
              ? "-"
              : _this.handlePointData(dataList[i].dcMainWireVolt);
          // 发电机输出电流
          dataList[i].dcMainWireCurr =
            dataList[i].dcMainWireCurr == 5553.5
              ? "-"
              : _this.handlePointData(dataList[i].dcMainWireCurr);
          // 发电机输出功率
          dataList[i].dcMainWirePower =
            dataList[i].dcMainWirePower == 5553.5
              ? "-"
              : _this.handlePointData(dataList[i].dcMainWirePower);
          // 发电机控制器温度
          dataList[i].igbttemp = _this.judgeEmpty(dataList[i].igbttemp);
        }
        if (_this.contrastVisible) {
          _this.vehicleData1 = dataList;
        } else if (!_this.contrastVisible) {
          _this.vehicleData = dataList;
        }
      } else {
        _this.loading = false;
        _this.$message.warning(res.msg);
      }
    },
    judgeEmpty(val) {
      if (val == "" || val == null) {
        return "-";
      } else {
        return val;
      }
    },
    // 处理充放电电流/充放电功率的精度
    handlePointData(val) {
      if (val == "" || val == null) {
        return "-";
      } else {
        return Number(val).toFixed(1);
      }
    },
    // 获取发电历史数据
    async getPowerData(curPage) {
      let _this = this;
      _this.loading2 = true;
      let obj = {
        recordId: _this.id,
        page: curPage,
        limit: _this.limit,
      };
      let { data: res } = await _this.$axios.get(
        "/api/vehicle/details/dynamo/history/record",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        _this.loading2 = false;

        let dataList = res.data.list;

        for (let i = dataList.length - 1; i >= 0; i--) {
          if (dataList[i].state == 0) {
            dataList[i].state = "未发电";
          } else if (dataList[i].state == 1) {
            dataList[i].state = "发电中";
          }
          dataList[i].generatorFuleConsumption =
            dataList[i].generatorFuleConsumption == 25.5
              ? ""
              : dataList[i].generatorFuleConsumption;
          dataList[i].overloadAlarm = _this.judgePowerData(
            dataList[i].overloadAlarm
          );
          //总正向有功功率
          dataList[i].forwardPower =
            dataList[i].forwardPower == 65535 ? "-" : dataList[i].forwardPower;
          dataList[i].phaseAlarm = _this.judgePowerData(dataList[i].phaseAlarm);
          dataList[i].shortAlarm = _this.judgePowerData(dataList[i].shortAlarm);
          dataList[i].gearsError = _this.judgePowerData(dataList[i].gearsError);
          dataList[i].cluthError = _this.judgePowerData(dataList[i].cluthError);
          dataList[i].diagnoseError = _this.judgePowerData(
            dataList[i].diagnoseError
          );
          dataList[i].ptoHighttemperatureAlarm = _this.judgePowerData(
            dataList[i].ptoHighttemperatureAlarm
          );
          dataList[i].addTs = _this.timestampToTime(dataList[i].addTs);
          dataList[i].makeUp = _this.handleMakeUpData(dataList[i].makeUp);
        }
        if (_this.contrastVisible) {
          _this.powerData1 = dataList;
          _this.pTotal = res.data.totalCount;
        } else if (!_this.contrastVisible) {
          _this.total = res.data.totalCount;
          _this.powerData2 = dataList;
        }
      } else {
        _this.loading2 = false;
        _this.$message.warning(res.msg);
      }
    },
    handleClick() {
      this.currentPage = 1;
      // this.$emit('exportData',this.activeName,this.data.startTime,this.data.endTime)
      if (this.activeName == "first") {
        this.getVehicleData(this.currentPage);
      } else if (this.activeName == "second") {
        this.getPowerData(this.currentPage);
      }
    },
    cloumnChoice() {
      let _this = this;
      this.checkedVehicle = [];
      this.checkedPower = [];
      this.choiceVehicleTitle = this.vehicleTitle;
      this.choicePowerTitle = this.powerTitle;
      console.log(this.vehicleTitle + "---" + this.powerTitle);
      this.vehicleTitle.forEach((item) => {
        let dataStr = "";
        dataStr = item.label + "&" + item.prop;
        _this.checkedVehicle.push(dataStr);
      });
      this.powerTitle.forEach((item) => {
        let dataStr = "";
        dataStr = item.label + "&" + item.prop;
        _this.checkedPower.push(dataStr);
      });
      this.choiceVisible = true;
    },
    // 全选（车辆）
    checkAllChange2(val) {
      this.checkedVehicle = val ? this.vehicleEcho : ["序号&index", "时间&ts"];
      this.powerIndeterminate2 = false;
      let data = this.checkedVehicle;
      let dataArr = [];
      data.forEach((item) => {
        let dataObj = {};
        dataObj.label = item.split("&")[0];
        dataObj.prop = item.split("&")[1];
        dataArr.push(dataObj);
      });

      this.choiceVehicleTitle = dataArr;
    },
    vehicleChange(val) {
      let checkedCount = val.length;
      this.checkAll2 = checkedCount === this.vehicleEcho.length;
      this.powerIndeterminate2 =
        checkedCount > 2 && checkedCount < this.vehicleEcho.length;
      let data = this.checkedVehicle;
      let dataArr = [];
      data.forEach((item) => {
        let dataObj = {};
        dataObj.label = item.split("&")[0];
        dataObj.prop = item.split("&")[1];
        dataArr.push(dataObj);
      });

      this.choiceVehicleTitle = dataArr;
    },
    // 全选（发电）
    checkAllChange1(val) {
      this.checkedPower = val ? this.powerEcho : ["序号&index", "时间&ts"];
      this.powerIndeterminate1 = false;
      let data = this.checkedPower;
      let dataArr = [];
      data.forEach((item) => {
        let dataObj = {};
        dataObj.label = item.split("&")[0];
        dataObj.prop = item.split("&")[1];
        dataArr.push(dataObj);
      });
      this.choicePowerTitle = dataArr;
    },
    powerChange(val) {
      let checkedCount = val.length;
      this.checkAll1 = checkedCount === this.powerEcho.length;
      this.powerIndeterminate1 =
        checkedCount > 2 && checkedCount < this.powerEcho.length;
      let data = this.checkedPower;
      let dataArr = [];
      data.forEach((item) => {
        let dataObj = {};
        dataObj.label = item.split("&")[0];
        dataObj.prop = item.split("&")[1];
        dataArr.push(dataObj);
      });
      this.choicePowerTitle = dataArr;
    },
    async choiceColumn() {
      this.choiceVisible = false;
      // 保存表头
      console.log(this.choiceVehicleTitle + "----" + this.choicePowerTitle);
      this.saveVehicleTitles(this.choiceVehicleTitle);
      this.savePowerTitles(this.choicePowerTitle);
      // 重新获取表头
    },
    async saveVehicleTitles(title) {
      console.log(title);
      let obj = {};
      obj.titles = title;
      obj.type = 1;
      let _this = this;
      obj.vin = _this.vin;
      let { data: res } = await _this.$axios.post(
        "/api/vehicle/details/history/title",
        obj
      );
      if (res.code == 1) {
        _this.getVehicleTitle();
        console.log(res.msg);
      } else {
        _this.$message.warning(res.msg);
      }
    },
    async savePowerTitles(title) {
      console.log(title);
      let obj = {};
      obj.titles = title;
      obj.type = 2;
      let _this = this;
      obj.vin = _this.vin;
      let { data: res } = await _this.$axios.post(
        "/api/vehicle/details/history/title",
        obj
      );
      if (res.code == 1) {
        _this.getPowerTitle();
        console.log(res.msg);
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //数据对比
    contrastData() {
      this.getVehicleTitle();
      this.getPowerTitle();
      this.contrastVisible = true;
      this.getVehicleData(this.currentPage1);
      this.getPowerData(this.pCurrentPage1);
      this.currentPage1 = 1;
      this.pCurrentPage1 = 1;
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      this.getVehicleData(this.currentPage1);
    },
    handlePCurrentChange1(val) {
      this.pCurrentPage1 = val;
      this.getPowerData(this.pCurrentPage1);
    },
    judgeData(data) {
      if (data === "" || data == null) {
        return "-";
      } else {
        if (data == 0) {
          return "无故障";
        } else if (data == 1) {
          return "故障";
        }
      }
    },
    judgePowerData(data) {
      if (data === "" || data == null) {
        return "-";
      } else {
        if (data == 0) {
          return "未告警";
        } else if (data == 1) {
          return "告警";
        }
      }
    },
    invalidData(data) {
      if (data === "" || data == null) {
        return "-";
      } else {
        if (data == "4294967295") {
          return "-";
        } else {
          return data;
        }
      }
    },
    speedHandle(val) {
      if (val == "" || val == null || val > 360) {
        return "-";
      } else {
        return val;
      }
    },
    handle255(val) {
      if (val == "" || val == null || val == 255) {
        return "-";
      } else {
        return val;
      }
    },
    handle25(val) {
      if (val == "" || val == null || val == 25.5) {
        return "-";
      } else {
        return val;
      }
    },
    handle207(val) {
      if (val == "" || val == null || val == 207) {
        return "-";
      } else {
        return val;
      }
    },
    engineHandle(val) {
      if (val == "" || val == null || val > 16383.5) {
        return "-";
      } else {
        return val;
      }
    },
    analysisEmsData(data) {
      if (data == 0) {
        return "OFF";
      } else if (data == 1) {
        return "ON";
      } else if (data == 2) {
        return "Reserved";
      } else if (data == 3) {
        return "Error";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.con-wrap {
  height: 100%;
  background: #f8f8f8 !important;
  padding: 0 20px !important;
  box-sizing: border-box;
  margin: 0;
}
.con-wrap /deep/ .mini-dialog .el-form-item__label {
  width: 110px;
}
.con-wrap .el-table {
  max-width: none;
}
.con-wrap .box-title {
  padding-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
  background: #f8f8f8;
}
.top {
  margin-bottom: 20px;
}
.data-wrap {
  width: 100%;
  height: 100%;
  padding: 20px 0px;
  box-sizing: border-box;
  .power-data {
    width: 100%;
    font-size: 14px;
    border: 1px solid #cccccc;
    border-left: none;
    .data-title {
      line-height: 40px;
      border-bottom: 1px solid #cccccc;
      text-align: center;
      font-weight: bold;
      color: #333333;
      .el-col {
        border-left: 1px solid #cccccc;
      }
    }
    .data-value {
      background: #fff;
      line-height: 40px;
      text-align: center;
      font-weight: 400;
      color: #333333;
      .el-col {
        border-left: 1px solid #cccccc;
      }
    }
  }
}
.data-box {
  width: 100%;
  height: calc(100% - 64px);
}
.pages {
  float: right;
  margin: 20px 20px 20px 0;
}
.data-box /deep/ .el-table--mini td {
  padding: 10px 0;
}
.data-box /deep/ .el-table--mini th {
  padding: 10px 0;
}
/deep/ .el-tabs {
  height: 100%;
  .el-tabs__nav-wrap {
    padding: 0 20px;
  }
  .el-tabs__content {
    height: calc(100% - 53px);
    background: #fff;
    padding: 20px;
    box-sizing: border-box;
  }
}
// 数据项选择
.dialog-title {
  height: 20px;
  padding-left: 10px;
  margin-bottom: 10px;
  border-left: 3px solid #0093ff;
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
.checkBoxs {
  height: 490px;
  width: 80%;
  padding: 10px 30px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 6px;
  margin: 0 auto;
}
.checkboxRow {
  display: block;
  height: 30px;
  line-height: 30px;
}
// .el-table__body-wrapper {
//   height: 477px;
// }
.contrastDialog {
  .vehicleTable /deep/ .el-table__fixed-body-wrapper {
    top: 47px !important;
  }
  .powerTable /deep/ .el-table__fixed-body-wrapper {
    top: 47px !important;
  }
}
.vehicleTable /deep/ {
  .el-table__header-wrapper {
    background-color: #f3f3f3;
  }
  .el-table__fixed-body-wrapper {
    top: 43px !important;
    height: 477px !important;
  }
  .el-table__fixed {
    height: 520px !important;
  }
  .el-table__body-wrapper {
    height: 477px !important;
    z-index: 2 !important;
  }
}
.powerTable /deep/ {
  .el-table__header-wrapper {
    background-color: #f3f3f3;
  }
  .el-table__fixed {
    height: 520px !important;
  }
  .el-table__fixed-body-wrapper {
    top: 43px !important;
    height: 477px !important;
  }
  .el-table__body-wrapper {
    height: 477px !important;
    z-index: 2 !important;
  }
}
// 数据比对
.contrastDialog /deep/ {
  .el-dialog {
    width: 88% !important;
  }
  .el-col-12 {
    padding: 10px !important;
    width: 49%;
    border: 1px solid #999;
    &:first-child {
      margin-right: 10px;
    }
  }
}
</style>
